import { Loader } from '@/components/loaders/loader';
import { TableBodyWrapper, TableWrapper } from '@/components/table/styles';
import TableHeader from '@/components/table/tableHeader';
import { ISort } from '@/components/table/types';
import { useResponsive } from '@/hooks/use-responsive';
import { Dispatch, SetStateAction } from 'react';
import styled from 'styled-components';
import { tenantsTableColumns } from '../constants';
import { ITenant } from '../types';
import MobileTable from './mobileTable';
import TableBody from './tableBody';

interface TenantsTableProps {
  tenantsTableTableData: ITenant[];
  sort: ISort;
  setSort: Dispatch<SetStateAction<ISort>>;
  loading: boolean;
  handleModalPage: (type: string, tenant?: ITenant) => void;
  openModalWindow: (type: string, tenant?: ITenant) => void;
}

const TenantsTable = ({ sort, setSort, loading, tenantsTableTableData, handleModalPage, openModalWindow }: TenantsTableProps) => {
  const { isMobile } = useResponsive();

  return (
    <TableWrapper padding="0">
      {isMobile ? (
        <>
          {loading ? (
            <Loader />
          ) : (
            <MobileTable tenantsTableTableData={tenantsTableTableData} handleModalPage={handleModalPage} openModalWindow={openModalWindow} />
          )}
        </>
      ) : (
        <>
          <CustomTableHeader refetch={() => {}} columns={tenantsTableColumns} savedSort={sort} savedSetSort={setSort} />
          <TableBodyWrapper>
            {loading ? (
              <Loader />
            ) : (
              <TableBody tenantsTableTableData={tenantsTableTableData} handleModalPage={handleModalPage} openModalWindow={openModalWindow} />
            )}
          </TableBodyWrapper>
        </>
      )}
    </TableWrapper>
  );
};

export default TenantsTable;

const CustomTableHeader = styled(TableHeader)`
  & span {
    white-space: nowrap;
  }
`;
